import React, {useEffect} from "react";
import {Panel} from 'primereact/panel';
import "./Curriculum.css";
import Chapter from "./Chapter";

const Curriculum = (props) => {
    const {course, setCourse} = props;

    return (
        <Panel header="Müfredat" className="curriculum">
            <p className="pb-5">Bölümler, dersler ve pratik faaliyetleri (sınavlar, kodlama egzersizleri ve ödevler)
                oluşturarak kursunuzu hazırlamaya başlayın.</p>
            <Chapter course={course} setCourse={(chapter) => setCourse(chapter)} />
        </Panel>
    )
};

export default Curriculum;
